import React, { useState, useEffect , useRef ,useContext } from "react";
import axios from 'axios';
import { Password } from "antd";
import { Input } from "antd";
// import './css/login-main.css';
import "./css/login.css";
import "./css/util-login.css";
import "./css/animation.css";
import "./css/animation.min.css";
import "../vendor/bootstrap/css/bootstrap.min.css";
import "../fonts/font-awesome-4.7.0/css/font-awesome.min.css";
import "../fonts/iconic/css/material-design-iconic-font.min.css";
import "../vendor/animate/animate.css";
import "../vendor/css-hamburgers/hamburgers.min.css";
import "../vendor/animsition/css/animsition.min.css";
import "../vendor/select2/select2.min.css";
import "../vendor/daterangepicker/daterangepicker.css";
import dine from "./images/login/coffee-shop_amico@2x.png";
import backImg from "./images/login/backImg.png";
import combined from "./images/login/combined.png";
import trial from "./images/login/trial.png";
import Logo from "./images/login/logoShersoft.png";
import check from "./images/icons/check-mark.png";
import checked from "./images/icons/checked.png";
import newWithLogo from "./images/login/new.png";
import Shersoft from "./images/Mobile/ss_logo.png";
import amico1 from "./images/Mobile/amico1.png";
import user from "./images/Mobile/user.png";
import lock from "./images/Mobile/lock.png";
import remove from "./images/icons/remove.png";
import Cookies from "js-cookie";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContainer, toast } from 'react-toastify';

import { DBContext } from './DBContext'

function Login() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const { customerCode , logginedDB , setLogginedDB, exitDatabase, getName, getUserType, getUserRights } = useContext(DBContext);

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [keepSignedIn, setKeepSignedIn] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()

    // //(location.state);

    useEffect(() => {
        const signupSuccess = localStorage.getItem('signupSuccess');
        if (signupSuccess) {
            toast.success(`Successfully created ${signupSuccess}`, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
            localStorage.removeItem('signupSuccess');
        }

        if (location.state === 'Logout') {
            localStorage.removeItem('DB');
            localStorage.removeItem('imgCode');
            localStorage.removeItem('Code');
            // Reset state to prevent clearing local storage on subsequent mounts
            navigate(location.pathname, { replace: true, state: null });
        } else if (location.state && location.state.companyName) {
            const success = location.state.companyName || ''
            if (success !== '') {
                toast.success(`Successfully created ${success}`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
                // Reset state to prevent clearing local storage on subsequent mounts
                navigate(location.pathname, { replace: true, state: null });
            }
        }

    }, [location.state, navigate, location.pathname]);

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const [selectedDB,setSelectedDB] = useState(null)

    useEffect(() => {
        if (logginedDB) {
            setSelectedDB(logginedDB)
        } else {
            setSelectedDB(null)
        }
        getCredentials()
    },[logginedDB,apiBaseUrl])

    function concate(db) {
        if (typeof db === 'string') {
            return db.replace(/\s+/g, ''); // Removes all spaces
        }
        return db; // Return the input if it's not a string
    }
    

    const handleLogin = async () => {
        if (username.trim() === "" || password.trim() === "") {
            // alert("Username or password cannot be empty");
            toast.warning("User Name and Password Required", {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
            return;
        }
        console.log(password, "checking something", username);
        
        try {
            console.log("inside login try");
            
            const response = await axios.get(
                `${apiBaseUrl}/loginDetails/${username}/${password}/${concate(selectedDB)}`
            );
            //("asda",response.status);
            console.log(response);
            
            if (response.status === 200) {
                // //("ok");
                console.log("true 1");

                // const userDB = `userdb_${username}`
                if (response.data.success) {
                    console.log("true 2");

                    const data = response.data;
                    console.log("3");
                    console.log(data);
                    
                    const userType = data.userType
                    console.log("4");
                    console.log(userType);
                    
                    // const userTypes = userType.userType
                    // console.log("6" , data, "hi", userType, "s", userTypes);
                    
                    if (Object.keys(data).length > 0) {
                        console.log("true 3")
                        // //(data[0]);
                        // console.log(data);
                        console.log('userType', userType);
                        console.log( userType.userType,"5");

                        const userTypes = userType.userType
                        console.log(`[Login] User Role: ${userTypes}`, "1444", userType);

                        const userObj = data.user || data[0];
                        const name = userObj.userFullName;
                        const id = userObj.id_user;
                        // const Company = data[0].companyName;
                        // const userDB = data[0].userDB;
                        localStorage.setItem('USER', name);
                        localStorage.setItem('userName', userObj.userName || username);
                        // localStorage.setItem('userType', userType || userTypes);
                        localStorage.setItem('userType', JSON.stringify(
                            // userType || 
                            userTypes));
                        localStorage.setItem('userRights', JSON.stringify(userType || {}));
                        localStorage.setItem('UI', id);
                        if (data.token) {
                            localStorage.setItem('token', data.token);
                        }
                        // localStorage.setItem('imgCode', imgCode);
                        // localStorage.setItem('Company', Company);
                        // //(data[0]);
                        if (keepSignedIn) {
                            storeCredentials(username,password)
                        }
                        // Sync the database context states with the new login credentials immediately
                        if (getName) getName();
                        if (getUserType) getUserType();
                        if (getUserRights) getUserRights();
                        
                        navigate('/ViewDashboard');
                        // Store in localStorage
                    }
                } else {
                    console.log("else");
                    
                    toast.error("Login failed. Invalid username or password", {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                }
            }
        } catch (error) {
            console.log("catch");
            
            console.error(error);
            const errorMessage = error.response?.data?.message || "Network error. Please check your internet connection.";
            
            toast.error(errorMessage, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }

    };

    const [userCredentials,setUserCredentials] = useState([])

    const [credentials,setCredentials] = useState([])


    const handleUsernameChange = (e) => {
        const val = e.target.value
        setUsername(val);
        const filteredCredentials = userCredentials.filter(cred => 
            cred.email.toLowerCase().includes(val.toLowerCase())
          );

        setCredentials(filteredCredentials)
        
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleCheckboxChange = (e) => {
        setKeepSignedIn(e.target.checked);
    };

    const [codeExists,setCodeExists] = useState(false)

    const handleExit = () => {
        exitDatabase();
        setDatabases([]);
        setStoredCode(null);
        setCodeExists(false);
        setUsername('');
        setPassword('');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLogin();
    };

    const manageCache = async (action, data = null) => {

        if (action === 'set' && data) {
            sessionStorage.setItem('Code',code)
        } else if (action === 'delete') {
            sessionStorage.removeItem('Code')
        }
        
        try {
            const cache = await caches.open('customer-code');
            const customUrl = '/Sherdine';
    
            if (action === 'set' && data) {
                // Create a response to store in the cache
                const response = new Response(JSON.stringify(data), {
                    headers: { 'Content-Type': 'application/json' },
                });
    
                // Set the cache entry
                await cache.put(customUrl, response);
                //('User rights cache set.');
            } else if (action === 'delete') {
                // Delete the specific cached entry
                const isDeleted = await cache.delete(customUrl);
                if (isDeleted) {

                } else {
                    //('No cache found for the given URL.');
                }
            } else if (action === 'get') {
                // Retrieve the cached response
                const cachedResponse = await cache.match(customUrl);
                if (cachedResponse) {
                    const cachedData = await cachedResponse.json();
                    //('Retrieved from cache:', cachedData);
                    return cachedData;
                } else {
                    //('No cache found for the given URL.');
                    return null;
                }
            }
        } catch (error) {
            console.error('Error managing cache:', error);
        }
    };


    const [code ,setCode] = useState(null)

    const handleCode = (e) => {
        const val = e.target.value
        setCode(val)
    }

    const [otpGenerated, setOtpGenerated] = useState(null)

    const [enteredOtp, setEnteredOtp] = useState("")

    // //(data.otp);

    const generateOTP = () => {
        return Math.floor(100000 + Math.random() * 900000);
    };

    const [countdown, setCountdown] = useState(300);

    // useEffect(() => {
    //     if (otpGenerated) {
    //         const countdownInterval = setInterval(() => {
    //             setCountdown((prevCountdown) => {
    //                 if (prevCountdown <= 1) {
    //                     clearInterval(countdownInterval);
    //                     setOtpGenerated(generateOTP())
    //                     return 0;
    //                 }
    //                 return prevCountdown - 1;
    //             });
    //         }, 1000);

    //         return () => clearInterval(countdownInterval);
    //     }
    // }, [otpGenerated]);

    const [Databases,setDatabases] = useState([])

   const [storedCode,setStoredCode] = useState(null)

   function removeSpaces(input) {
        return input.replace(/\s+/g, ''); //// Remove all spaces using regex
    }
    
   const fetchData = async (code) => {
        try {
            // Fetch verify code from the API
            const response = await axios.get(`${apiBaseUrl}/getVerifyCode/${code}`);
            if (response.status === 200) {
                if (response.data.length == 1) {
                    const DB = response.data[0].Code
                    setSelectedDB(response.data[0].name)
                    localStorage.setItem('DB', DB);
                } else {
                    setDatabases(response.data);
                }
                setStoredCode(code)
            }
        } catch (error) {
            console.error('Error fetching verify code:', error);
        }
    };

    useEffect(() => {
        if (customerCode) {
            fetchData(customerCode);
        }
    }, [customerCode]);
    
    
    const handleVerify = async () => {
        if (String(otpGenerated) === String(enteredOtp)) {
            try {
                const response = await axios.get(`${apiBaseUrl}/getVerifyCode/${code}`)
                if (response.status == 200) {
                    manageCache('set',code)
                    localStorage.setItem('Code', code);
                    if (response.data.length == 1) {
                        setSelectedDB(response.data[0].name)
                        const DB = response.data[0].Code
                        localStorage.setItem('DB', DB);
                        localStorage.setItem('Name', response.data[0].name);
                    } else {
                        setDatabases(response.data);
                    }
                }
            } catch (error) {
                
            }
        } else {
            toast.error(`Invalid OTP!`, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }
        
    }

    const handleCheckCodeExist = async () => {
        console.log("Checking code existence for:");
        try {
            const response = await axios.get(`${apiBaseUrl}/checkCodeExist/${code}`);
            console.log("response ", response);
            
            if (response.status === 200) {
                console.log("response data ");
            
                // Check if the code exists
                if (response.data.exists === 1) {
                    console.log("Code exists");
                    // If code exists, proceed with OTP generation and sending
                    handleSend();
                    setCodeExists(true)
                    toast.success(`OTP successfully sent to ${code}`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                } else {
                    // If code does not exist, handle accordingly (e.g., show an error message)
                    toast.error(`${code} does not exist!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                }
            }
        } catch (error) {
            console.error("Error checking code existence:", error.message);
            toast.error("Error checking code existence.", {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }
    };

    const handleSend = async () => {
        const OTP = generateOTP()
        setOtpGenerated(OTP)

        try {
            const response = await axios.post(`${apiBaseUrl}/verifyCode/${OTP}/${code}`);
            toast.dismiss();
            if (response.ok) {
                toast.success(`OTP successfully sent to ${code}`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
                setCountdown(30);
                const countdownInterval = setInterval(() => {
                    setCountdown((prevCountdown) => {
                        if (prevCountdown <= 1) {
                            clearInterval(countdownInterval);
                            setOtpGenerated(generateOTP())
                            return 0;
                        }
                        return prevCountdown - 1;
                    });
                }, 1000);
            }

        } catch (error) {
            toast.dismiss();
            console.error('Error sending OTP:', error);
            toast.error("Failed to send OTP. Please try again.", {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }
    };

    const inputRefs = useRef([]);

    const inputRefsMob = useRef([]);

    const handleOtpChange = (event, index, screen) => {
        const value = event.target.value;
      
        if (/^\d$/.test(value)) {
            //("hiiii");

          const updatedOtp = enteredOtp.split('');
          updatedOtp[index] = value;
          setEnteredOtp(updatedOtp.join(''));
      
          // Move focus to the next input field if available
          if (screen === 'd') {
            if (index < inputRefs.current.length - 1) {
                inputRefs.current[index + 1].focus();
              }
          } else if (screen === 'm') {
            if (index < inputRefsMob.current.length - 1) {
                inputRefsMob.current[index + 1].focus();
              }
          }
        }
      };
    
    
    // const handlePaste = (event) => {
    //     const pastedData = event.clipboardData.getData("Text");
    //     const numericData = pastedData.replace(/\D/g, "").slice(0, 6);

    //     setEnteredOtp(numericData);

    //     const inputs = document.querySelectorAll('.otpinput');
    //     inputs.forEach((input, idx) => {
    //         input.value = numericData[idx] || '';
    //         if (numericData[idx] && idx < inputs.length - 1) {
    //         inputs[idx + 1].focus();
    //       }
    //     });
    //   };
    const handlePaste = (event) => {
        const pastedData = event.clipboardData.getData("Text");
        const numericData = pastedData.replace(/\D/g, "").slice(0, 6); // Only take first 6 digits
    
        setEnteredOtp(numericData); // Update OTP state
    
        const inputs = document.querySelectorAll('.otpinput');
        inputs.forEach((input, idx) => {
            input.value = numericData[idx] || ''; // Set the value for each input
            if (numericData[idx] && idx < inputs.length - 1) {
                inputs[idx + 1].focus(); // Focus the next input
            }
        });
    };

    const handlePasteMob = (event) => {
        const pastedData = event.clipboardData.getData("Text");
        const numericData = pastedData.replace(/\D/g, "").slice(0, 6); // Only take first 6 digits
    
        setEnteredOtp(numericData); // Update OTP state
    
        const inputs = document.querySelectorAll('.otpinputmob');
        inputs.forEach((input, idx) => {
            input.value = numericData[idx] || ''; // Set the value for each input
            if (numericData[idx] && idx < inputs.length - 1) {
                inputs[idx + 1].focus(); // Focus the next input
            }
        });
    };

    const [focusedIndex, setFocusedIndex] = useState(0);
    const rowRefs = useRef([]);

    // Handle the arrow keys for row navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            setFocusedIndex((prevIndex) => Math.min(prevIndex + 1, Databases.length - 1));
        } else if (e.key === "ArrowUp") {
            setFocusedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        }
        };

        // Listen to the keydown events
        window.addEventListener("keydown", handleKeyDown);

        // Cleanup listener on component unmount
        return () => {
        window.removeEventListener("keydown", handleKeyDown);
        };
    }, [Databases.length]);

    useEffect(() => {
        // Focus on the first row initially
        rowRefs.current[focusedIndex]?.focus();
      }, [focusedIndex]);


    const handleRowClick = (index,db) => {
        setFocusedIndex(index)
        // handleRowDoubleClick(db)
    };

    const handleRowDoubleClick = (db) => {
        // alert(`Enter pressed on: ${db.name}`);
        
        setSelectedDB(db.name)
        const DB = removeSpaces(db.name)
        setLogginedDB(DB)
        localStorage.setItem('DB', DB);
        localStorage.setItem('Name', db.name);
    };

    const handleClearCode = () => {
        // To delete cache
        localStorage.removeItem('Code')
        manageCache('delete');
        setDatabases([]);
        setStoredCode(null)
    }

    const [credState,setCredState] = useState(false)

    // //(userCredentials);

    const handleFocus = () => {
        setCredState(true)
    }

    const handleRemoveCred = (e,email) => {
        //("hii");
        
        e.stopPropagation()
        // Retrieve existing credentials from localStorage
        let credentials = JSON.parse(localStorage.getItem('userCredentials')) || [];
      
        // Filter out the credential with the matching email
        credentials = credentials.filter(cred => cred.email !== email);
      
        // Update localStorage with the filtered credentials
        localStorage.setItem('userCredentials', JSON.stringify(credentials));
      
        //(`Credentials for ${email} removed successfully.`);
      };
      

    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleBlurMobile = () => {
        setCredState(false)
    }
    
    const handleClickMobile = (cred, e) => {
        e.stopPropagation();
        setUsername(cred.email)
        setPassword(cred.password)
        setCredState(false)
        setSelectedIndex(-1);
    };

    function storeCredentials(email, password) {
        // Retrieve existing credentials from localStorage
        let credentials = JSON.parse(localStorage.getItem('userCredentials')) || [];
      
        // Check if the email and password already exist
        const exists = credentials.some(cred => cred.email === email && cred.password === password);
      
        if (!exists) {
          // Add the new email-password pair if it doesn't exist
          credentials.push({ email, password });
      
          // Store updated credentials back in localStorage
          localStorage.setItem('userCredentials', JSON.stringify(credentials));
        }
      }
      

    function getCredentials() {
        const credentials = JSON.parse(localStorage.getItem('userCredentials')) || [];
        setUserCredentials(credentials)
    }

    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const passRef = useRef(null);

    const handleKeyDown = (e) => {
        if (userCredentials.length === 0) return;

        e.stopPropagation()

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault(); // Prevent number type input changes
        }

        if (e.key === 'ArrowDown') {
            setSelectedIndex((prevIndex) => (prevIndex === userCredentials.length - 1 ? 0 : prevIndex + 1));
        } else if (e.key === 'ArrowUp') {
            setSelectedIndex((prevIndex) => (prevIndex <= 0 ? userCredentials.length - 1 : prevIndex - 1));
        } else if (e.key === 'Enter' && selectedIndex >= 0) {
            setUsername(userCredentials[selectedIndex].email)
            setPassword(userCredentials[selectedIndex].password)
            setCredState(false)
            setSelectedIndex(-1);
            if (passRef.current) {
                passRef.current.focus();
            }
        }
    };

    const handleWheel = (event) => {
        if (document.activeElement === inputRef.current) {
            event.preventDefault();
        }
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.addEventListener('keydown', handleKeyDown);
            inputRef.current.addEventListener('wheel', handleWheel);
        }

        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener('keydown', handleKeyDown);
                inputRef.current.removeEventListener('wheel', handleWheel);
            }
        };
    }, [selectedIndex, userCredentials]);

    useEffect(() => {
        if (dropdownRef.current && selectedIndex >= 0) {
            const selectedElement = dropdownRef.current.children[selectedIndex];
            if (selectedElement) {
                selectedElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        }
    }, [selectedIndex]);
      

    return (
        <div className="w-screen h-screen flex overflow-hidden">
            <div className="w-full h-full hidden sm:flex">
                <div className="LeftSideDivLogin">
                    <img className="CombinedImgLogin" src={newWithLogo} alt="SherSoft" />
                </div>
                <div className="RightSideDivLogin">
                    {
                        selectedDB ? (
                            <div className="LoginFormMainDiv w-full p-20">
                                <h4 className="TitleTextLogin">Login To {selectedDB && selectedDB.toUpperCase()}</h4> 
                                <div className="LoginForm">
                                    <div className="EMailLogin">
                                        <span className="EmailTextLogin">E-Mail / User Name</span>
                                        <div className="InputEmailLogin relative">
                                            <input
                                                className="InputEmailTextLogin"
                                                ref={inputRef}
                                                type="text"
                                                name="username"
                                                value={username || ''}
                                                onChange={handleUsernameChange}
                                                onFocus={handleFocus}
                                                onBlur={handleBlurMobile}
                                                placeholder=""
                                            />
                                            {credState && credentials.length > 0 && (
                                                <div className='absolute transform translate-x-0 translate-y-0 w-full p-[2px] gap-[2px] min-h-0 z-[9999] max-h-[7rem] overflow-auto customScrollSelect flex flex-col border bg-[#fff] text-[.85rem] rounded-[.313rem] mt-1' >
                                                    {credentials.map((cred, index) => (
                                                        <div
                                                            key={index}
                                                            className={`w-full flex pb-[2px] text-[#000] cursor-pointer ${selectedIndex === index ? 'bg-[#eaeaea]' : 'bg-[#f4f4f4]'
                                                                }`}
                                                            onMouseEnter={() => setSelectedIndex(index)}
                                                            onMouseDown={(e) => handleClickMobile(cred, e)}
                                                        >
                                                            <div className="w-full p-1 text-nowrap overflow-x-auto noScroll font-sans">{cred.email}</div>
                                                            <div className="w-max p-2 flex justify-center items-center">
                                                                <img className="w-[1rem] opacity-75" src={remove} alt="" onClick={(e) => handleRemoveCred(e,cred.email)}/>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="PasswordLogin">
                                        <span className="PasswordTextLogin">Password</span>
                                        <div
                                            className="InputPasswordLogin"
                                            data-validate="Enter password"
                                        >
                                            <input
                                                ref={passRef}
                                                className="InputPasswordTextLogin"
                                                value={password || ''}
                                                onChange={handlePasswordChange}
                                                type={showPassword ? "text" : "password"}
                                                placeholder=""
                                            />
                                        </div>
                                    </div>
                                    <div className="RememberMeForgotPassword">
                                        <div className="RememberMeCheckbox">
                                            <input
                                                type="checkbox"
                                                id="rememberMeId"
                                                checked={keepSignedIn}
                                                onChange={handleCheckboxChange}
                                            />
                                            <label className="rememberMe">Remember Me</label>
                                        </div>
                                        <div className="ForgotPasswordLink">
                                            <a className="ForgotPasswordLinkLogin" onClick={() => navigate('/Forgetpass')}>Forgot Password?</a>
                                        </div>
                                    </div>
                                    <div className="flex w-full gap-2">
                                        <button className="w-1/2 flex justify-center items-center loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] p-2" onClick={handleSubmit}>
                                            Login
                                        </button>
                                        <button className="w-1/2 flex justify-center items-center loginBorder text-[#0008B4] rounded-[.313rem] p-2" onClick={handleExit}>
                                            Exit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="LoginFormMainDiv w-full p-20 max-h-screen">
                                <h4 className="font-josefin font-[900] text-[1.5em]">Admin</h4>
                                <div className="LoginForm h-full gap-3">
                                    {
                                        Databases.length > 0 ? (
                                            <div className="flex w-full gap-2">
                                                <div className="flex justify-start items-center gap-2 w-full">
                                                    <span className="text-[#000] opacity-50">{storedCode || code}</span>
                                                    <img className="w-[1rem]" src={check} alt="" />
                                                </div>
                                                <div className="flex justify-end items-center gap-2 w-max text-nowrap text-[#0008B4]">
                                                    <button className="cursor-pointer text-[1rem] bg-[#0008B4] text-[#fff] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3" onClick={handleClearCode}>Clear</button>
                                                </div>
                                            </div>
                                        ) : Databases.length == 0 && (
                                            <div className="flex flex-col gap-2">
                                                {
                                                    codeExists ? (
                                                        <span className="EmailTextLogin">Enter OTP send to {code}</span>
                                                    ) : (
                                                        <span className="EmailTextLogin">Customer Code / Email</span>
                                                    )
                                                }
                                                <div className="InputEmailLogin">
                                                    {
                                                        codeExists ? (
                                                            <div className="flex gap-2">
                                                                {Array.from({ length: 6 }).map((_, index) => (
                                                                    <input
                                                                    key={index}
                                                                    type="text"
                                                                    className="otpinput w-1/6 p-2 flex text-center justify-center items-center"
                                                                    maxLength="1"
                                                                    onChange={(e) => handleOtpChange(e, index, 'd')}
                                                                    onPaste={handlePaste}
                                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                                    />
                                                                  ))}
                                                            </div>
                                                        ) : (
                                                            <input
                                                                className="InputEmailTextLogin"
                                                                type="text"
                                                                name="code"
                                                                value={code || ''}
                                                                onChange={handleCode}
                                                                placeholder=""
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        Databases.length > 0 ? (
                                            <div className="flex flex-col w-full h-full rounded-[.313rem] gap-1 overflow-hidden">
                                                <div className="flex w-full gap-1">
                                                    <div className="w-1/5 p-2 bg-[#dcdcdc] rounded-tl-[.313rem] text-center">SI</div>
                                                    <div className="w-2/5 p-2 bg-[#dcdcdc]">Company</div>
                                                    <div className="w-2/5 p-2 bg-[#dcdcdc] rounded-tr-[.313rem]">Year</div>
                                                </div>
                                                <div className="flex flex-col w-full h-full gap-1 text-[.95rem] overflow-auto">
                                                    {Databases.map((db, index) => (
                                                        <div
                                                            key={index}
                                                            ref={(el) => (rowRefs.current[index] = el)} // Assign ref to each row
                                                            className='flex w-full gap-1 focus:outline-none'
                                                            tabIndex={0} // Make the row focusable
                                                            onClick={() => handleRowClick(index,db)}
                                                            onDoubleClick={() => handleRowDoubleClick(db)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") handleRowDoubleClick(db);
                                                            }}
                                                        >
                                                            <div className={`w-1/5 p-2 cursor-default text-center ${focusedIndex === index ? 'bg-blue-200' : 'bg-[#f7f7f7]'}`}>{index + 1}</div>
                                                            <div className={`w-2/5 p-2 cursor-default ${focusedIndex === index ? 'bg-blue-200' : 'bg-[#f7f7f7]'}`}>{db.name}</div>
                                                            <div className={`w-2/5 p-2 cursor-default ${focusedIndex === index ? 'bg-blue-200' : 'bg-[#f7f7f7]'}`}>{db.sdate} - {db.edate}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : Databases.length == 0 && (
                                            <div className="w-full flex flex-col gap-3">
                                                <div className="LoginButtonDiv">
                                                    {
                                                        codeExists ? (
                                                            <button className="LoginButtonLoginPage" onClick={handleVerify}>
                                                                Verify
                                                            </button>
                                                        ) : (
                                                            <button className="LoginButtonLoginPage" onClick={handleCheckCodeExist}>
                                                                Send
                                                            </button>
                                                        )
                                                    }
                                                </div>
                                                {
                                                    codeExists ? (
                                                        <div className="AccNewSignUp">
                                                            Don't you received code yet ?&nbsp;<span className="AccNewSignUp_Span" onClick={handleCheckCodeExist}>Resend</span>
                                                        </div>
                                                    ) : (
                                                        <div className="AccNewSignUp">
                                                            Don't you have an account yet ?&nbsp;<span className="AccNewSignUp_Span" onClick={() => navigate('/Signup')}>Sign up</span>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
export default Login;
